import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';

@Component({
  selector: 'delete-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './delete-confirmation.component.html',
  styleUrl: './delete-confirmation.component.css'
})
export class DeleteConfirmationComponent {
  icons = Icons;

  @Input() itemToDelete: any | null = null;
  @Input() text: string | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<any>();


  cancelDelete(): void {
    this.onClose.emit();
  }

  deleteItem(): void {
    this.onDelete.emit(this.itemToDelete);
  }
}
